/* =========================================================
   LABOOSH — CUSTOM JS
   Loaded on every page from layout/theme.liquid
   ========================================================= */

(function () {
  'use strict';

  // Only run on the home page
  if (!document.body.classList.contains('template-index')) return;

  // Sections whose backgrounds are dark — header should be WHITE
  var DARK_SECTIONS = [
    'shopify-section--laboosh-hero',
    'shopify-section--laboosh-banner'
  ];

  // Sections whose backgrounds are light — header should be BLACK
  var LIGHT_SECTIONS = [
    'shopify-section--laboosh-categories',
    'shopify-section--laboosh-trio',
    'shopify-section--laboosh-ig'
  ];

  // Returns 'dark' or 'light' for a given section element
  function getTreatment(section) {
    // Allow section-level override via data attribute, e.g.:
    //   <section data-header-treatment="dark"> ... </section>
    if (section.dataset && section.dataset.headerTreatment) {
      return section.dataset.headerTreatment;
    }
    for (var i = 0; i < DARK_SECTIONS.length; i++) {
      if (section.classList.contains(DARK_SECTIONS[i])) return 'dark';
    }
    for (var j = 0; j < LIGHT_SECTIONS.length; j++) {
      if (section.classList.contains(LIGHT_SECTIONS[j])) return 'light';
    }
    return 'light'; // default to dark logo on unknown sections
  }

  function applyTreatment(treatment) {
    if (treatment !== 'dark' && treatment !== 'light') return;
    var body = document.body;
    var current = body.classList.contains('header-on-dark') ? 'dark'
                : body.classList.contains('header-on-light') ? 'light'
                : null;
    if (current === treatment) return;
    body.classList.remove('header-on-dark', 'header-on-light');
    body.classList.add('header-on-' + treatment);
  }

  // Find the header so we know how tall it is — that's the "probe line"
  // we use to determine which section is currently behind it.
  function getProbeY() {
    var header = document.querySelector('header-component, .header-section');
    if (!header) return 60;
    var rect = header.getBoundingClientRect();
    // probe a few pixels below the header's bottom edge
    return Math.max(rect.bottom + 10, 60);
  }

  function update() {
    var sections = document.querySelectorAll(
      '.content-for-layout .shopify-section, main .shopify-section'
    );
    if (!sections.length) return;

    var probeY = getProbeY();
    var found = null;

    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      var rect = s.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom > probeY) {
        found = s;
        break;
      }
    }

    if (found) {
      applyTreatment(getTreatment(found));
    }
  }

  // Throttle scroll/resize via requestAnimationFrame
  var ticking = false;
  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  // Initial run — once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  // Re-run after Shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();